import * as React from 'react';

export const MobilePdfEditPage = () => {
    return <div>Редактирование на мобильном устройстве не поддерживается</div>;
};
